<template>
    <!-- :max="parameters.max || parameters.max === 0 ? parameters.max : Infinity" -->
    <!-- parameters.max || parameters.max === 0 ? parameters.max : 9999999999999999 -->
    <!-- :max="max" -->
    <a-input-number
        v-model="changeValue"
        style="width: 100%"
        :min="parameters.min || parameters.min === 0 ? parameters.min : -Infinity"
        :precision="parameters.precision"
        :step="parameters.step"
        :placeholder="parameters.placeholder"
        :formatter="inputNumberF"
        :parser="inputNumberP"
        @blur="onBlur"
        @focus="onFocus"
        @keyup.17="onKeyUp"
        @keypress="onKeyPress"
        @paste="onPaste"
        @change="handleChange"
    >
    </a-input-number>
</template>

<script>
import { DataEntryMixin } from './mixins';
import { encryptedRender } from '@/utils/dynamic';

export default {
    name: 'SdEncryptFieldNumber',
    mixins: [DataEntryMixin],
    data(){
        return{
            isFocus: false, // 是否处于焦点状态
            isValidTrue: true, // 校验是否正确
            originValHidden: null,
            originVal: null,
            isEncryptField: true, // 是否需要加密
        };
    },
    computed: {
        changeValue: {
            get() {
                if(!this.isFocus && this.isValidTrue){
                    if(!this.originVal){
                        this.originVal = this.value;
                    }
                    if(this.isEncryptField){
                        return this.originVal;
                    }
                    else{
                        // return this.originValHidden;
                        if(this.originValHidden) return String(this.originValHidden).substr(0,this.parameters.maxLength);
                        else return this.originValHidden;
                    }
                }
                else{
                    return this.originValHidden;
                }
            },
            set(val) {
                // 补充字数限制
                if(val && String(val).length > this.parameters.maxLength){
                    console.log('字数超出限制')
                    return
                }else{
                    this.originValHidden = val;
                    this.$emit('update:value', val);
                    this.$forceUpdate();
                }
            },
        },
        max({$props}){
            let max1 = this.parameters.max === 0?9:(Math.pow(10, this.parameters.maxLength) - 1);
            return max1 || 9999999999999999
        },
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
    },
    methods: {
        inputNumberF(value){
            if(!this.isFocus && this.isEncryptField){
                return encryptedRender(value);
            }
            else{
                return this.originValHidden ? value.substr(0, this.parameters.maxLength) : this.originValHidden;
            }
        },
        inputNumberP(value){
            return value;
        },
        onBlur(val){
            this.isFocus = false;
            this.$emit('onValidate');
        },
        onFocus(){
            this.isFocus = true;
        },
        onKeyPress(){
            console.log('监听输入');
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
        },
        onKeyUp(){
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
        },
        onPaste(){
            // 代表有變動過，到保存之前都不加密
            this.isEncryptField = false;
            console.log('粘貼');
        },
        handleChange(val){
            // 精度问题，暂时使用最长16位长度
            // if(val&&String(val).length>16) val = Number(String(val).slice(0,15))
            // console.log(val,this.changeValue)

            this.isEncryptField = false;
        }
    }
};
</script>

<style scoped lang="less">
/deep/ .ant-input-number-handler-wrap{
    display: none;
}
</style>
